import React from "react";

const ContactPage = () => {
  const contacts = [
    { label: "Support", email: "support@recallcore.ai", desc: "For account access, billing questions, platform issues, and general help.", color: "#00e5cc" },
    { label: "Privacy", email: "privacy@recallcore.ai", desc: "For data access, correction, deletion, and privacy-related requests.", color: "#0066ff" },
    { label: "Legal", email: "legal@recallcore.ai", desc: "For legal notices, disputes, and formal legal communications.", color: "#6633ff" },
  ];
  return (
    <div style={{ minHeight: "100vh", background: "#080c18", color: "#c8d4e0", fontFamily: "JetBrains Mono, monospace" }}>
      <div style={{ borderBottom: "1px solid #0d1e35", padding: "16px 32px" }}>
        <div style={{ maxWidth: "760px", margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <a href="/" style={{ color: "#00e5cc", fontSize: "13px", textDecoration: "none" }}>← RecallCore</a>
          <div style={{ display: "flex", gap: "24px" }}>
            <a href="/privacy" style={{ color: "#2a4060", fontSize: "12px", textDecoration: "none", letterSpacing: "0.06em", textTransform: "uppercase" }}>Privacy</a>
            <a href="/terms" style={{ color: "#2a4060", fontSize: "12px", textDecoration: "none", letterSpacing: "0.06em", textTransform: "uppercase" }}>Terms</a>
            <a href="/contact" style={{ color: "#00e5cc", fontSize: "12px", textDecoration: "none", fontWeight: 600, letterSpacing: "0.06em", textTransform: "uppercase" }}>Contact</a>
          </div>
        </div>
      </div>
      <div style={{ maxWidth: "760px", margin: "0 auto", padding: "72px 32px 100px" }}>
        <div style={{ marginBottom: "56px" }}>
          <p style={{ fontSize: "11px", letterSpacing: "0.2em", textTransform: "uppercase", color: "#1a3a5a", marginBottom: "12px", fontWeight: 600 }}>RecallCore</p>
          <h1 style={{ fontSize: "36px", fontWeight: "700", color: "#ffffff", letterSpacing: "-0.02em", marginBottom: "16px", lineHeight: "1.1" }}>Contact</h1>
          <p style={{ fontSize: "15px", color: "#3a5a7a", lineHeight: "1.7", maxWidth: "480px" }}>For support, privacy requests, legal inquiries, and platform-related questions.</p>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "48px" }}>
          {contacts.map((c) => (
            <a key={c.label} href={`mailto:${c.email}`} style={{ textDecoration: "none", display: "block" }}>
              <div style={{ padding: "24px 28px", background: "#0a1220", border: "1px solid #0d1e35", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "16px", cursor: "pointer", transition: "border-color 0.15s, background 0.15s" }} onMouseEnter={e => { e.currentTarget.style.borderColor = c.color + "44"; e.currentTarget.style.background = "#0c1828"; }} onMouseLeave={e => { e.currentTarget.style.borderColor = "#0d1e35"; e.currentTarget.style.background = "#0a1220"; }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "6px" }}>
                    <div style={{ width: "6px", height: "6px", borderRadius: "50%", background: c.color, flexShrink: 0 }} />
                    <span style={{ fontSize: "13px", fontWeight: "600", color: "#8090b0", letterSpacing: "0.08em", textTransform: "uppercase" }}>{c.label}</span>
                  </div>
                  <p style={{ fontSize: "13px", color: "#3a5070", lineHeight: "1.6", margin: "0 0 10px 16px" }}>{c.desc}</p>
                  <p style={{ fontSize: "14px", color: c.color, margin: "0 0 0 16px", fontWeight: 500 }}>{c.email}</p>
                </div>
                <span style={{ fontSize: "16px", color: "#1a3050", flexShrink: 0 }}>→</span>
              </div>
            </a>
          ))}
        </div>
        <hr style={{ border: "none", borderTop: "1px solid #0d1e35", margin: "0 0 40px" }} />
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px" }}>
          <div>
            <p style={{ fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#1a3050", fontWeight: 600, marginBottom: "14px" }}>Business Address</p>
            <div style={{ fontSize: "13px", color: "#3a5070", lineHeight: "2" }}>
              <p style={{ margin: 0, color: "#5a7090", fontWeight: 500 }}>Codex Multiverse Limited</p>
              <p style={{ margin: 0 }}>Unit 2A, 17/F, Glenealy Tower</p>
              <p style={{ margin: 0 }}>No.1 Glenealy, Central</p>
              <p style={{ margin: 0 }}>Hong Kong S.A.R.</p>
            </div>
          </div>
          <div>
            <p style={{ fontSize: "11px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#1a3050", fontWeight: 600, marginBottom: "14px" }}>Response Times</p>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <div style={{ padding: "12px 14px", background: "#0a1220", border: "1px solid #0d1e35", borderRadius: "7px" }}>
                <p style={{ fontSize: "11px", color: "#2a4060", textTransform: "uppercase", letterSpacing: "0.08em", margin: "0 0 4px", fontWeight: 600 }}>General Support</p>
                <p style={{ fontSize: "13px", color: "#3a5570", margin: 0 }}>10 business days</p>
              </div>
              <div style={{ padding: "12px 14px", background: "#0a1220", border: "1px solid #0d1e35", borderRadius: "7px" }}>
                <p style={{ fontSize: "11px", color: "#2a4060", textTransform: "uppercase", letterSpacing: "0.08em", margin: "0 0 4px", fontWeight: 600 }}>Privacy & Legal</p>
                <p style={{ fontSize: "13px", color: "#3a5570", margin: 0 }}>May require additional verification</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ borderTop: "1px solid #0a1a30", padding: "20px 32px", textAlign: "center" }}>
        <p style={{ fontSize: "12px", color: "#1a2e48", margin: 0 }}>
          © 2026 RecallCore · Codex Multiverse Limited &nbsp;·&nbsp;
          <a href="/privacy" style={{ color: "#1a3050", textDecoration: "none" }}>Privacy</a>&nbsp;·&nbsp;
          <a href="/terms" style={{ color: "#1a3050", textDecoration: "none" }}>Terms</a>&nbsp;·&nbsp;
          <a href="/contact" style={{ color: "#1a3050", textDecoration: "none" }}>Contact</a>
        </p>
      </div>
    </div>
  );
};

export default ContactPage;


